import { useGetAuthenticatedUser } from 'Flux/Selector/index.js'
import { Navigate } from 'react-router-dom'
import { useUserWasFetched } from '../../../Flux/Selector/Authentication/GetAuthenticatedUser/UserWasFetchedSelector.js'
import { HomeDashboardPage } from './HomeDashboardPage.tsx'

export const HomePage = () => {
  const authenticatedUser = useGetAuthenticatedUser()
  const userWasFetched = useUserWasFetched()

  if (!userWasFetched) {
    return <></>
  }

  if (!authenticatedUser) {
    return <Navigate to={'/'} />
  }

  return <HomeDashboardPage />
}
